// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__EV1tB","checkboxCol":"Table_checkboxCol__1n8c-","emailCol":"Table_emailCol__1lzbr","actionCol":"Table_actionCol__1QneR"};